import { createSelector } from 'reselect';
import { catalogQuickAtbSelector } from 'selectors/testTarget/offers/catalogQuickAtb/catalogQuickAtbSelector';

const showSelector = createSelector(catalogQuickAtbSelector, catalogQuickAtb => !!catalogQuickAtb.show);

export { showSelector };
